/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import ReviewsLink from "./Link";

const ReviewCard = ({ props }) => {
    const { logo, rating, ratingDesc, color, name, link } = props;
    return (
        <div
            css={css`
                min-width: 34rem;
                background: #fff;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                border-radius: 2rem;
                box-shadow: 0px 0px 8px 2px rgb(0 0 0 / 14%);
            `}
        >
            <div
                css={css`
                    background-color: #f2f2f2;
                    padding: 2rem;
                    border-top-right-radius: 2rem;
                    border-top-left-radius: 2rem;
                    height: 8rem;
                `}
            >
                <img css={css`margin: auto;`} src={logo} alt={name} width="126" />
            </div>
            <div css={css`
                display: contents;
            `}>
                <p
                    css={css`
                        display: inline-block;
                        text-align: center;
                        font-size: 4rem;
                        line-height: 5rem;
                        color: #fff;
                        background-color: ${color};
                        padding: 1.5rem;
                        border-radius: 7rem;
                        min-width: 7rem;
                        min-height: 7rem;
                        margin: 2rem auto;
                    `}
                >
                    {rating}
                </p>
                <div css={css`
                    position: relative;
                    display: flex;
                    justify-content: center;
                `}>
                    <StarIcon fill={color} />
                    <StarIcon fill={color} />
                    <StarIcon fill={color} />
                    <StarIcon fill={color} />
                    <StarIcon fill={color} />
                </div>
                <p
                    css={css`
                        font-size: 1.5rem;
                        line-height: 2rem;
                        margin: 1rem;
                        color: #c8c8c8;
                    `}
                >
                    {ratingDesc}
                </p>

                <ReviewsLink color="#393972" to={link} />
            </div>
        </div>
    );
};

export default ReviewCard;

const StarIcon = (props) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={css`margin-left: 0.2rem; margin-right: 0.2rem;`}
    >
        <path
            d="M17.2263 7.10568C17.1695 6.93055 17.0182 6.80291 16.8361 6.77647L11.7211 6.03268L9.43347 1.39462C9.35207 1.22951 9.18401 1.125 9.00003 1.125C8.81601 1.125 8.64798 1.22951 8.56655 1.39462L6.27886 6.03268L1.16388 6.77647C0.981833 6.80291 0.83053 6.93055 0.773682 7.10565C0.716803 7.28079 0.76424 7.47302 0.896014 7.60152L4.59715 11.2118L3.72356 16.3095C3.69243 16.491 3.767 16.6744 3.91586 16.7826C4.00006 16.8438 4.0998 16.875 4.20003 16.875C4.27698 16.875 4.3542 16.8567 4.4249 16.8194L8.99999 14.4125L13.5749 16.8194C13.7378 16.9051 13.9351 16.8908 14.084 16.7826C14.2328 16.6744 14.3074 16.491 14.2763 16.3095L13.4024 11.2118L17.104 7.60149C17.2357 7.47302 17.2832 7.28079 17.2263 7.10568Z"
            fill={props.fill}
        />
    </svg>
);
